import numeral from 'numeral';

function addCommas(number) {
  return numeral(number).format('0,0');
}

function getAreaString(min, max) {
  if (min && max) {
    return `${addCommas(min)}m² - ${addCommas(max)}m²`;
  }
  if (min && !max) {
    return `Above ${addCommas(min)}m²`;
  }
  if (!min && max) {
    return `Below ${addCommas(max)}m²`;
  }
  return '';
}

export default function getFormattedArea({ minFloorArea, maxFloorArea, minSiteArea, maxSiteArea }) {
  // Has site area only
  if ((!minFloorArea && !maxFloorArea) && (!!minSiteArea || !!maxSiteArea)) {
    return getAreaString(minSiteArea, maxSiteArea);
  }
  // Has floor area only
  if (!!minFloorArea || !!maxFloorArea) {
    return getAreaString(minFloorArea, maxFloorArea);
  }
  // Has no area information
  return '';
}
